// Header mapping from Excel to internal field names
export const HEADER_MAPPING = {
	'Customer Name *': 'customerName',
	'Display Name': 'displayName',
	'Mobile *': 'mobile',
	'Email': 'email',
	'Gender *': 'gender',
	'Date of Birth * (DD-MM-YYYY)': 'dob',
	'Age *': 'age',
	'Height (CM) *': 'height',
	'Weight (Kgs) *': 'weight',
	'Occupation': 'occupation',
	'Address': 'address',
	'Aadhaar Number': 'aadhaarNo',
	'On-Boarded By (Coach ID) *': 'onBoardedBy',
	'Referred By (Customer ID)': 'referredBy',
	'Service ID *': 'serviceId',
	'Membership ID *': 'membershipId',
	'Amount *': 'amount',
	'Paid *': 'paid',
	'Balance (Auto)': 'balance',
	'Joining Date * (DD-MM-YYYY)': 'joiningDate',
	'Paid On * (DD-MM-YYYY)': 'paidOn',
	'Next Bill Date * (DD-MM-YYYY)': 'nextBillDate',
	'Payment Method * (cash/upi)': 'paymentMethod',
	'UPI Transaction ID': 'upiTransactionId',
	'Remarks': 'remarks',
};

// Required columns for validation
export const REQUIRED_COLUMNS = [
	'customerName',
	'mobile',
	'gender',
	'dob',
	'age',
	'height',
	'weight',
	'onBoardedBy',
	'serviceId',
	'membershipId',
	'amount',
	'paid',
	'joiningDate',
	'paidOn',
	'nextBillDate',
	'paymentMethod',
];

// Column validation rules
export const COLUMN_VALIDATIONS = {
	customerName: { type: 'string', required: true, minLength: 2, message: 'Customer name must be at least 2 characters' },
	displayName: { type: 'string', required: false },
	mobile: { type: 'string', required: true, pattern: /^\d{10}$/, message: 'Mobile must be exactly 10 digits' },
	email: { type: 'email', required: false, pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, message: 'Invalid email format' },
	gender: { type: 'string', required: true, enum: ['male', 'female'], message: 'Gender must be male or female' },
	dob: { type: 'date', required: true, message: 'Date of birth is required (format: DD-MM-YYYY)' },
	age: { type: 'number', required: true, min: 1, max: 120, message: 'Age must be between 1 and 120' },
	height: { type: 'number', required: true, min: 50, max: 300, message: 'Height must be between 50-300 CM' },
	weight: { type: 'number', required: true, min: 20, max: 300, message: 'Weight must be between 20-300 Kgs' },
	occupation: { type: 'string', required: false },
	address: { type: 'string', required: false },
	aadhaarNo: { type: 'string', required: false, pattern: /^\d{12}$/, message: 'Aadhaar must be exactly 12 digits' },
	onBoardedBy: { type: 'string', required: true, message: 'Coach ID is required' },
	referredBy: { type: 'string', required: false },
	serviceId: { type: 'string', required: true, message: 'Service ID is required' },
	membershipId: { type: 'string', required: true, message: 'Membership ID is required' },
	amount: { type: 'number', required: true, min: 0, message: 'Amount must be 0 or greater' },
	paid: { type: 'number', required: true, min: 0, message: 'Paid amount must be 0 or greater' },
	balance: { type: 'number', required: false, min: 0 },
	joiningDate: { type: 'date', required: true, message: 'Joining date is required (format: DD-MM-YYYY)' },
	paidOn: { type: 'date', required: true, message: 'Paid on date is required (format: DD-MM-YYYY)' },
	nextBillDate: { type: 'date', required: true, message: 'Next bill date is required (format: DD-MM-YYYY)' },
	paymentMethod: { type: 'string', required: true, enum: ['cash', 'upi'], message: 'Payment method must be cash or upi' },
	upiTransactionId: { type: 'string', required: false },
	remarks: { type: 'string', required: false },
};

// Reverse mapping for display purposes
export const getExcelColumnName = (fieldName) => {
	const mapping = Object.entries(HEADER_MAPPING).find(([excelName, field]) => field === fieldName);
	return mapping ? mapping[0] : fieldName;
};
